
import {
  computed, defineComponent, inject, PropType, ref,
} from 'vue';
import { useClipboard } from '@vueuse/core';
import { useRoute } from 'vue-router';

import {
  CASE_SHARE_POPUP_STATES, SHARE_TYPES, NAVIGATION_PAGES, APPLICATION_SETTINGS_TYPE,
} from '@/types/enums';
import { useMainStore } from '@/store/mainStore';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import BottomPopUpItem from '../../BottomPopUpItem.vue';
import NativeService from '@/services/NativeService';
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  components: {
    BottomPopUpItem,
  },
  emits: ['switchState'],
  props: {
    itemType: { type: Number as PropType<SHARE_TYPES>, required: true },
  },
  setup(props) {
    const driveStore = useDriveStore();
    const { copy, copied } = useClipboard();
    const route = useRoute();
    const mainStore = useMainStore();
    // eslint-disable-next-line @typescript-eslint/ban-types
    const $localize = inject('$localize') as Function;

    const currentPage = computed(() => (route.meta.navigationPage));

    const caseUrl = computed(() => (process.env.VUE_APP_DOMAIN_URL || '') + driveStore.currentCase.externalUrl);

    const isInstagramShareEnabled = computed(() => {
      const featureEnabled = mainStore.applicationSettings.find((feature) => feature.name === APPLICATION_SETTINGS_TYPE.INSTAGRAM_SHARE)?.enabled;
      const { isNative } = mainStore;
      const isCase = props.itemType === SHARE_TYPES.CASE;
      const isFile = props.itemType === SHARE_TYPES.FILE;

      return featureEnabled && isNative && !isCase && !isFile;
    });

    const shareData = ref({
      title: $localize('drive.public.case.shared.title'),
      text: $localize('drive.public.case.shared.text'),
      url: caseUrl,
    });
    function onCopy() {
      if (driveStore.currentCase.accessedByExternalUrl) {
        copy(caseUrl.value);
      }
    }

    function shareOnInstagram() {
      MonitoringService.logEvents({
        logType: 'instagramButton',
        userId: mainStore.user?.accountId,
        key: 'CLICK',
        id: '',
      });
      if (driveStore.appPhotoViewMedia && driveStore.appPhotoViewMedia.fileUrl && driveStore.appPhotoViewMedia.type) {
        NativeService.shareOnInstagram(process.env.VUE_APP_MEDIA_URL + driveStore.appPhotoViewMedia.fileUrl, driveStore.appPhotoViewMedia.type);
      }
    }

    async function shareLink() {
      if (currentPage.value === NAVIGATION_PAGES.CASE_VIEW && driveStore.currentCase.accessedByExternalUrl) {
        try {
          await navigator.share(shareData.value);
        } catch (error) {
          console.error('Error sharing:', error);
        }
      }
    }

    return {
      CASE_SHARE_POPUP_STATES,
      SHARE_TYPES,
      shareData,
      shareLink,
      onCopy,
      copied,
      currentPage,
      NAVIGATION_PAGES,
      driveStore,
      mainStore,
      shareOnInstagram,
      isInstagramShareEnabled,
    };
  },
});
